import { GetterTree } from 'vuex';
import { Preparation, PreparationState } from '@/store/lessons/preparation/types';
import { RootState } from '@/store/types';

const getters : GetterTree<PreparationState, RootState> = {
  /**
   * レッスンIDからpreparationを取得
   * @param {string} lessonId レッスンID（スケジュールID）
   */
  findPreparationByLessonId: (state) => (lessonId: string): Preparation|null => {
    return state.preparation
  },
};

export default getters;
